import http from '~/common/http';
import Config from "~/config/params";

function cloneParams(params) {
    return JSON.parse(JSON.stringify(params || {}));
}

function pickFields(source, fields) {
    let target = {};
    fields.forEach(field => {
        if (source && Object.prototype.hasOwnProperty.call(source, field)) {
            target[field] = source[field];
        }
    });
    return target;
}

function cleanReviseParams(params, scenario) {
    let data = cloneParams(params);
    data.scenario = scenario;

    if (Array.isArray(data.products)) {
        const productFields = [
            'id', 'product_id', 'order_id', 'product_name', 'name', 'price', 'old_price',
            'code', 'product_code', 'allow_config', 'type', 'type_id', 'type_name',
            'start_at', 'end_at', 'start_at_fomat', 'end_at_fomat', 'effect_at',
            'memo', 'product_memo', 'config', 'is_enable', 'open_state', 'is_new',
            'refund_amount', 'quantity', 'disruption_id'
        ];
        data.products = data.products.map(product => pickFields(product, productFields));
    }

    if (Array.isArray(data.user)) {
        const userFields = [
            'no', 'id', 'user_id', 'order_id', 'branch_id', 'name', 'pfm_amount',
            'renew_amount', 'finish_amount', 'is_cooperator', 'is_cooperator_str'
        ];
        data.user = data.user.map(user => pickFields(user, userFields));
    }

    if (Array.isArray(data.plan_pay)) {
        const payFields = [
            'no', 'id', 'customer_id', 'order_id', 'user_id', 'plan_at',
            'plan_amount', 'actual_at', 'actual_amount', 'type'
        ];
        data.plan_pay = data.plan_pay.map(pay => pickFields(pay, payFields));
    }

    if (Array.isArray(data.sale_user)) {
        data.sale_user = data.sale_user.map(user => ({
            user_id: user.user_id,
            name: user.name,
            pfm_amount: user.pfm_amount,
            renew_amount: user.renew_amount,
            finish_amount: user.finish_amount,
            is_cooperator: user.is_cooperator
        }));
    }

    return data;
}

//新建订单产品信息
function createProduct(params) {
    params.scenario = 'orderProduct';
    return http.post('/api/order/create', params);
}

//更新订单产品信息
function updateProduct(params) {
    params.scenario = 'orderProduct';
    return http.post('/api/order/update', params);
}

//修订产品信息
function reviseProduct(params) {
    return http.post('/api/order/revise', cleanReviseParams(params, 'orderProduct'));
}

//修订财务信息
function reviseFinance(params) {
    return http.post('/api/order/revise', cleanReviseParams(params, 'orderFinance'));
}

//修订合同信息
function reviseContract(params) {
    return http.post('/api/order/revise', cleanReviseParams(params, 'orderContract'));
}

/**
 * 获取订单修订的内容
 * @param id
 * @returns {AxiosPromise<any>}
 */
function getReviseContent(id) {
    return http.get('/api/order/revise-order', {
        params: {
            id: id
        }
    });
}

function close(params) {
    return http.post('/api/order/close', params);
}
function trialOrderClose(params) {
    return http.post('/api/order/trial-order-close', params);
}


//获取订单流程处理进度
function getProgress(order_id, type = 0, revise_id = 0) {
    return http.get('/api/flow/order-progress', {
        params: {
            id: order_id,
            type: type,
            revise_id: revise_id
        }
    });
}

//新建订单财务信息
function createFinance(params) {
    params.scenario = 'orderFinance';
    return http.post('/api/order/create', params);
}

//更新订单财务信息
function updateFinance(params) {
    params.scenario = 'orderFinance';
    return http.post('/api/order/update', params);
}

//新建订单合同信息
function createContract(params) {
    params.scenario = 'orderContract';
    return http.post('/api/order/create', params)
}

//更新订单合同信息
function updateContract(params) {
    params.scenario = 'orderContract';
    return http.post('/api/order/update', params)
}

//订单列表
function list(params) {
    return http.get('/api/order/index', {
        params: params
    });
}

//订单列表
function commonList(params) {
    return http.get('/api/common/get-orders', {
        params: params
    });
}

//我的订单列表
function myList(params) {
    return http.get('/api/order/my-order', {
        params: params
    });
}

//我的协作单列表
function myCorOrder(params) {
    return http.get('/api/order/my-cor-order', {
        params: params
    });
}

//订单详情
function getDetail(order_id) {
    return http.get('/api/order/view', {
        params: {
            id: order_id
        }
    });
}

//修改订单
function save(params) {
    return http.post('/api/order/update', params)
}


//补充发票信息 fill_type=4
function fillInvoice(params) {
    params.fill_type = 4;
    return http.post('/api/order/fill', params);
}

//编辑发票信息
function editInvoice(params) {
    return http.post('/api/order/edit-invoice', params);
}

//添加寄件内容
function addSending(params) {
    return http.post('/api/order/add-sending', params);
}

//录入物流信息
function addLogistics(params) {
    return http.post('/api/order/add-logistics', params);
}

//更新物流信息
function updateLogistics(params) {
    return http.post('/api/order/update-logistics', params);
}

//删除物流信息
function logisticsDel(id) {
    return http.get('/api/order/del-logistics', {params: {id: id}});
}

//更新物流状态
function logisticsStatus(params) {
    return http.post('/api/order/logistics-status', params);
}

//开具发票
function issue(params) {
    return http.post('/api/order/issue', params);
}

function clear(order_id) {
    return http.post('/api/order/clear', {id: order_id});
}

//删除订单 软删除
function deleteOrder(order_id) {
    return http.delete('/api/order/delete', {
        params: {
            id: order_id
        }
    });
}

//回款计划列表
function payment(params) {
    return http.get('/api/order/payment', {params: params})
}

//我的回款计划列表
function myPayment(params) {
    return http.get('/api/order/my-payment', {params: params})
}

//回款统计
function paymentCount(params) {
    return http.get('/api/order/payment-count', {params: params})
}

//更新回款计划
function updatePayLog(params) {
    return http.post('/api/order/update-pay-log', params);
}

//录入回款计划
function addPayLog(params) {
    return http.post('/api/order/add-pay-log', params);
}

//删除回款计划
function deletePayLog(params) {
    return http.post('/api/order/delete-pay-log', params);
}

//删除发票
function deleteInvoice(params) {
    return http.post('/api/order/delete-invoice', params);
}

//删除我的发票
function deleteMyInvoice(params) {
    return http.post('/api/order/delete-my-invoice', params);
}

//主管审批
function checkBusiness(params) {
    return http.post('/api/order/check-business', params)
}

/**
 * 删除协作人
 * @param params
 * @returns {AxiosPromise<any>}
 */
function delCorp(params) {
    return http.get('/api/order/del-corp', {params: params})
}

/**
 * 发票列表
 * @param params
 * @returns {*}
 */
function invoice(params) {
    return http.get('/api/order/invoice', {params: params})
}


function addNewInvoiceContext(params) {
    return http.post('/api/order/create-invoice-centext', {params: params})
}

function myInvoice(params) {
    return http.get('/api/order/my-invoice', {params: params})
}
function myInvoiceContext(is_delete = []) {
    return http.get('/api/order/invoice-context', {
        params: {
            is_delete: is_delete
        }
    })
}

function getExportOrderField() {
    return http.get('/api/order/get-export-order-field')
}

//退款记录
function refundLog(params) {
    return http.get('/api/order/refund-log', {
        params: params
    });
}

//物流列表
function logisticsList(params) {
    return http.get('/api/order/logistics-list', {
        params: params
    });
}


//修订备注
function setMemo(params) {
    return http.post('/api/order/set-memo', params);
}

// //全部合同盖章列表
// function getContractSeal(params) {
//     return http.get('/api/order/contract-seal', {params: params})
// }

// //我的合同盖章列表
// function getMyContractSeal(params) {
//     return http.get('/api/order/my-contract-seal', {params: params})
// }

function invoiceTypes() {
    return [
        {
            value: '1',
            label: '教育软件'
        }, {
            value: '2',
            label: '教育资源软件'
        }, {
            value: '3',
            label: '校本资源库软件'
        }, {
            value: '4',
            label: '区县教育云平台软件'
        },
        {
            value: '5',
            label: '软件开发'
        },
        {
            value: '6',
            label: '信息服务费'
        }, {
            value: '7',
            label: '技术服务费'
        }, {
            value: '9',
            label: '资源服务费'
        }, {
            value: '8',
            label: '教育培训服务费'
        }, {
            value: '10',
            label: '教育资源服务费'
        },
        {
            value: '11',
            label: '教师培训服务费'
        },
        {
            value: '12',
            label: '题库资源'
        },
        {
            value: '13',
            label: '教师培训费'
        },
        {value: 14, label: '二一教育智慧校园软件V1.0-在线组卷'},
        {value: 15, label: '二一教育智慧校园软件V1.0-校本资源库'},
        {value: 16, label: '二一教育智慧校园软件V1.0-课堂无忧'},
        {value: 17, label: '二一教育排课软件'},
        {value: 18, label: '网络推广服务'},
    ];
}

function options() {
    return [{
        value: 1,
        label: '中通快递'
    }, {
        value: 2,
        label: '圆通快递'
    }, {
        value: 3,
        label: '顺丰快递'
    }, {
        value: 4,
        label: '韵达快递'
    }, {
        value: 6,
        label: '邮政快递'
    }, {
        value: 7,
        label: '德邦快递'
    }, {
        value: 5,
        label: '其他'
    }]
}

function goodsType() {
    return [{
        value: '1',
        label: '合同'
    }, {
        value: '2',
        label: '发票'
    }, {
        value: '3',
        label: '报销资料'
    }, {
        value: '4',
        label: '礼品'
    }, {
        value: '5',
        label: '其他'
    }]
}


function getOrderType(type = '') {
    return [
        {
            value: '',
            label: '不限',
            disabled: type == 'formal'
        },
        {
            value: Config.TYPE_TRY_OUT,
            label: '试用',
            disabled: type == 'formal'
        }, {
            value: Config.TYPE_FORMAL,
            label: '正式(新单)'
        }, 
        {
            value: Config.TYPE_RENEW,
            label: '正式(续单)',
            children: [
              {
                value: Config.TYPE_RENEW_BEFORE,
                label: '提前续费'
              },
              {
                value: Config.TYPE_RENEW_TIMELY,
                label: '准时续费'
              },
              {
                value: Config.TYPE_RENEW_AFTER,
                label: '延迟续费',
              }
            ]
        },
        {
            value: Config.TYPE_FORMAL_AND_RENEW,
            label: '正式'
        }
    ]
}

//得到客户筛选项配置
function getFields(params) {
    const tab = params.tab;
    const path = params.path;
    return [
        {field: 'base', label: '基础信息筛选条件', children: [
            {field: 'customer_name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
            {field: 'id', label: '订单ID', type: 'input'},
            {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict'},
            path == '/order/my-order' && tab == 'cooperator' ? {field: 'user_type', label: '协作单类型', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '我是协作人'}, {value: 2, label: '我是负责人'}]} : null,
            {field: 'product_ids', label: '产品类型', type: 'components', ref: 'product', components: 'Product', change: 'getValue', multiple: true, clearable: true},
            {field: 'product_type', label: '开通版本', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '标准版'}, {value: 2, label: '额度版'}]},
            path != '/order/my-order' ? {field: 'branch_id', label: '所属部门', type: 'components', ref: 'branch', components: 'UserCascader', change: 'changeCascaderLast'} : null,
            path != '/order/my-order' ? {field: 'salesman', label: '订单负责人', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'} : null,
            {field: 'type', label: '订单类型', type: 'components', ref: 'order_type', components: 'OrderType', change: 'changeCascaderLast', params: params},
            {field: 'sign_mode', label: '签单模式', type: 'select', list: [{value: '', label: '不限'}, {value: 0, label: '普通订单'}, {value: 1, label: '代理自签单'}, {value: 2, label: '代理代签单'}, {value: 3, label: '经销订单'}]},
            {field: 'source', label: '成交来源', type: 'select', list: [{value: '', label: '不限'}, {value: 0, label: '无'}, {value: 1, label: '线索转化'}, {value: 2, label: '业务员自拓'}, {value: 3, label: '客户转介绍'}, {value: 4, label: '学海行舟公益行'}, {value: 5, label: '国培教育'}, {value: 7, label: '400官网高价值线索'}, {value: 8, label: '运营孵化高价值线索'}, {value: 9, label: '龙岗区教育局'}]},
            {field: 'is_close', label: '是否关闭', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]},
            {field: 'close_type', label: '关闭类型', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '取消合作'}, {value: 2, label: '操作错误'}, {value: 4, label: '取消合同'}, {value: 3, label: '其他'}]},
            {field: 'close_audit', label: '关闭状态', type: 'select', list: [{value: '', label: '不限'}, {value: Config.TYPE_NO_CHECKED, label: '待审核'}, {value: Config.TYPE_CHECKED, label: '通过'}, {value: Config.TYPE_CHECKED_FAIL, label: '全部'}]},
            {field: 'finance_audit', label: '财务审核', type: 'select', list: Config.orderCheckStatus()},
            {field: 'repay_type', label: '回款情况', type: 'select', list: [{value: 0, label: '不限'}, {value: 1, label: '未回款'}, {value: 2, label: '部分回款'}, {value: 3, label: '全部回款'}]},
            {field: 'contract_audit', label: '合同审核', type: 'select', list: Config.orderCheckStatus()},
        ]},
        {field: 'date', label: '时间筛选条件', children: [
            {field: 'created_time', label: '录单时间', type: 'daterange'},
            {field: 'plan_time', label: '计划回款时间', type: 'daterange'},
            {field: 'pay_time', label: '回款时间', type: 'daterange'},
            {field: 'upload_file_time', label: '传附时间', type: 'daterange'},
            {field: 'contract_start_time', label: '合同开始时间', type: 'daterange'},
            {field: 'contract_end_time', label: '合同结束时间', type: 'daterange'},
            {field: 'send_time', label: '寄出日期', type: 'daterange'},
            {field: 'input_at', label: '开票日期', type: 'daterange'},
            {field: 'revise_audit_time', label: '修订审核时间', type: 'daterange'}, // 添加修订审核时间
            {field: 'close_audit_time', label: '关闭审核时间', type: 'daterange'}, // 添加关闭审核时间
        ]},
        {field: 'other', label: '其他筛选条件', children: [
            {field: 'contract_number', label: '合同编号', type: 'input'},
            {field: 'total_amount_type', label: '合同金额', type: 'select', list: [{value: '', label: '不限'}, {value: 0, label: '0'}, {value: 1, label: '1~10000'}, {value: 2, label: '10001~50000'}, {value: 3, label: '50001~100000'}, {value: 4, label: '100001~'}]},
            {field: 'stage', label: '合作学段', type: 'select', list: Config.getStages()},
            {field: 'channel', label: '联系人来源', type: 'components', ref: 'channel', components: 'ChannelCascader', change: 'changeCascaderLast'},
            {field: 'cooperate_status', label: '是否正式合作', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]},
        ]},
    ];
}

function getOrderExportFields() {
    return [
        {field: 'base', label: '基本信息', children: [
            {'label': '订单id', 'field': 'id'},
            {'label': '客户名称', 'field': 'customer_name'},
            {'label': '客户id', 'field': 'customers.id'},
            {'label': '客户绑定业务员', 'field': 'customer_user_name'},
            {'label': '订单负责人', 'field': 'user_name'},
            {'label': '订单接管人', 'field': 'take_over_name'},
            {'label': '部门', 'field': 'branch_name'},
            {'label': '地区', 'field': 'districts'},
            {'label': '订单类型', 'field': 'order_type'},
            {'label': '签单模式', 'field': 'sign_mode'},
            {'label': '订单学段', 'field': 'order_stage'},
            {'label': '学校规模', 'field': 'customer_size'},
            {'label': '录单时间', 'field': 'created_at'},
            {'label': '审核状态', 'field': 'audit_status'},
            {'label': '订单来源', 'field': 'order_source'},
            {'label': '联系人来源', 'field': 'contacts_source'},
            {'label': '订单数量', 'field': 'order_num'},
            {'label': '成交产品', 'field': 'products'},
        ]},
        {field: 'finance', label: '财务信息', children: [
            {'label': '销售额', 'field': 'total_amount'},
            {'label': '新增业绩', 'field': 'pfm_amount'},
            {'label': '应续金额', 'field': 'to_renew_amount'},
            {'label': '续费目标单', 'field': 'target_id'},
            {'label': '续费业绩额', 'field': 'renew_amount'},
            {'label': '续费完成额', 'field': 'finish_amount'},
            {'label': '总回款金额', 'field': 'total_pay'},
            {'label': '实际回款金额', 'field': 'this_actual_amount'},
            {'label': '回款状态', 'field': 'pay_status'},
            {'label': '回款计划', 'field': 'pay_plan'},
            {'label': '最新回款时间', 'field': 'last_pay_at'},
        ]},
        {field: 'contract', label: '合同信息', children: [
            {'label': '合作年限', 'field': 'contracts_yeas'},
            {'label': '合同开始时间', 'field': 'contract_start_time'},
            {'label': '合同到期时间', 'field': 'contract_end_time'},
            {'label': '上传合同日期', 'field': 'contracts_created_at'},
        ]},
        {field: 'other', label: '其他信息', children: [
            {'label': '发票抬头', 'field': 'invoices_title'},
            {'label': '纳税人识别号', 'field': 'taxpayer_id'},
            {'label': '开票日期', 'field': 'input_info'},
            {'label': '收件人', 'field': 'recipient'},
            {'label': '联系电话', 'field': 'mobile'},
            {'label': '寄件地址', 'field': 'address'},
            {'label': '物流信息', 'field': 'logistics_info'},
            {'label': '备注', 'field': 'memo'},
        ]},
    ];
}


/**
 * 获取产品修改日志
 * @param params
 * @returns {*}
 */
function getRecord(params) {
    return http.get('/api/order/product-record', {params: params})
}

function statusOptions() {
    return [
        {
            value: 1,
            label: '已签收'
        },
        {
            value: 0,
            label: '未签收'
        }
    ]
}

function sendStatus() {
    return [
        {
            value: 0,
            label: '待发货'
        },
        {
            value: 1,
            label: '部分发货'
        },
        {
            value: 2,
            label: '全部发货'
        }
    ]
}

/**
 * 获取审核状态
 */
function showCheckInfo(row) {
    let str = '';
    if (row.finance_audit == 3 && row.undo_finance > 0) {
        str += '<span style="color: red">财务信息已撤销</span>' + "</br>";
    } else if (row.finance_audit == 3) {
        str += '财务信息未填写' + "</br>";
    } else if (row.finance_audit == 0) {
        str += '<span style="color: #F56C6C">财务审核不通过' + "</span></br>";
    }
    if (row.contract_audit == 3 && row.undo_contract > 0) {
        str += '<span style="color: red">合同信息已撤销</span>' + "</br>";
    } else if (row.contract_audit == 3 && row.type!=1) {
        str += '<span style="color: #F56C6C">合同附件未上传' + "</span></br>";
    } else if (row.contract_audit == 0 && row.type!=1) {
        str += '<span style="color: #F56C6C">合同审核不通过' + "</span></br>";
    }
    if (row.finance_audit == 2) str += '<span style="color: #E6A23C">财务信息待【' + row.finance_auditor + '】审核' + "</span></br>";
    if (row.contract_audit == 2) str += '<span style="color: #E6A23C">合同附件待【' + row.contract_auditor + '】审核' + "</span></br>";
    if (row.finance_audit == 1) str += '<span style="color: #67C23A">财务信息审核通过' + "</span></br>";
    if (row.contract_audit == 1) str += '<span style="color: #67C23A">合同附件审核通过' + "</span></br>";
    return str;
}

function getOrderChangeLogs(params) {
    return http.get('/api/order/change-logs', {params: params})
}


export default {
    getRecord,
    payment,
    myPayment,
    paymentCount,
    myInvoice,
    myInvoiceContext,
    invoice,
    showCheckInfo,
    logisticsDel,
    updateLogistics,
    logisticsStatus,
    addSending,
    addLogistics,
    deleteOrder,
    close,
    trialOrderClose,
    clear,
    fillInvoice,
    editInvoice,
    createProduct,
    createFinance,
    createContract,
    list,
    commonList,
    getDetail,
    save,
    checkBusiness,
    getReviseContent,
    issue,
    myList,
    addPayLog,
    updatePayLog,
    deletePayLog,
    invoiceTypes,
    options,
    goodsType,
    getOrderType,
    getFields,
    getOrderExportFields,
    statusOptions,
    sendStatus,
    deleteInvoice,
    deleteMyInvoice,
    delCorp,
    myCorOrder,
    updateContract,
    updateFinance,
    updateProduct,
    getProgress,
    reviseContract,
    reviseProduct,
    reviseFinance,
    getOrderChangeLogs,
    addNewInvoiceContext,
    getExportOrderField,
    refundLog,
    logisticsList,
    setMemo,
}



// WEBPACK FOOTER //
// ./src/services/order.js